import type { ReactNode, SVGProps } from 'react';

export type IconName =
  | 'activity'
  | 'agents'
  | 'archive'
  | 'chevron'
  | 'close'
  | 'discovery'
  | 'history'
  | 'library'
  | 'more'
  | 'publications'
  | 'refresh'
  | 'settings'
  | 'spark';

const paths: Record<IconName, ReactNode> = {
  publications: <><path d="M4 5.5h5.5v5.5H4z" /><path d="M14.5 5.5H20v5.5h-5.5z" /><path d="M4 16h5.5v2.5H4z" /><path d="M14.5 16H20v2.5h-5.5z" /></>,
  discovery: <><circle cx="12" cy="12" r="7.5" /><path d="m15.2 8.8-1.7 4.7-4.7 1.7 1.7-4.7z" /></>,
  library: <><path d="M5 4.5h4v15H5zM9 6h5v13.5H9zM15.5 5l3.4-.7 2.8 14.8-3.4.7z" /></>,
  activity: <path d="M3.5 12h3l2-5 3.2 10 2.4-7 1.8 2h4.6" />,
  agents: <><circle cx="9" cy="9" r="3" /><circle cx="17" cy="8" r="2.2" /><path d="M3.8 19c.6-3.2 2.4-4.8 5.2-4.8s4.7 1.6 5.2 4.8M14.5 13.5c2.9-.6 4.8.7 5.7 3.8" /></>,
  settings: <><circle cx="12" cy="12" r="3" /><path d="M12 3.5v2M12 18.5v2M3.5 12h2M18.5 12h2M6 6l1.4 1.4M16.6 16.6 18 18M18 6l-1.4 1.4M7.4 16.6 6 18" /></>,
  history: <><path d="M5.3 7.2H2.8V4.7" /><path d="M4 6a8 8 0 1 1-.1 11.9" /><path d="M12 7.5V12l3 2" /></>,
  archive: <><path d="M4 7.5h16v12H4zM3 4h18v3.5H3z" /><path d="M9.5 11h5" /></>,
  chevron: <path d="m9 6 6 6-6 6" />,
  close: <path d="m7 7 10 10M17 7 7 17" />,
  refresh: <><path d="M19 8V4l-2 2a7.5 7.5 0 1 0 1.6 8" /></>,
  more: <><circle cx="5" cy="12" r="1" fill="currentColor" stroke="none" /><circle cx="12" cy="12" r="1" fill="currentColor" stroke="none" /><circle cx="19" cy="12" r="1" fill="currentColor" stroke="none" /></>,
  spark: <><path d="M12 3.5 13.4 9l4.1 3-4.1 3L12 20.5 10.6 15l-4.1-3 4.1-3z" /></>,
};

export function Icon({ name, ...props }: { name: IconName } & SVGProps<SVGSVGElement>) {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.6"
      {...props}
    >
      {paths[name]}
    </svg>
  );
}
